import React, { FC } from 'react';

import Account from './atoms/Account';
import Cart from './atoms/Cart';
import Search from './atoms/Search';

import styles from './index.module.sass';

const Buttons: FC = () => (
  <div className={styles.container}>
    <Search />

    <Account />

    <Cart />
  </div>
);

export default Buttons;
